  <div class="mb-2">
    <app-top-cases></app-top-cases>
  </div>
  <div class="mb-3">
    <div class="mb-2" *ngFor="let exp of masterSer.explore_array">
      <p class="paragraph-bold pb-2 px-2 seprator-line-btm">{{exp.group_name}}</p>
      <ul class="row m-0">
        <li class="mb-2 col-6 px-1" *ngFor="let expProd of exp.products" [ngClass]="{'d-none': expProd.value === navigationTarget.MY_DOWNLOAD
          || expProd.value === navigationTarget.CONTRIBUTOR
          || expProd.value === navigationTarget.REWARDS
          || expProd.value === navigationTarget.CHATS}">
          <div class="position-relative">
            <app-custom-tooltip class="max-width-tooltip"
              *ngIf="tooltip_data?.length>0 && expProd.value === navigationTarget.CME" [tooltip_data]="tooltip_data"
              [view_identifier]="exploreIdentifiers.EXPLORE_CME" [position]="position.TOP_LEFT">
            </app-custom-tooltip>
  
            <app-custom-tooltip class="max-width-tooltip"
              *ngIf="tooltip_data?.length>0 && expProd.value === navigationTarget.SURVEY" [tooltip_data]="tooltip_data"
              [view_identifier]="exploreIdentifiers.EXPLORE_SURVEYS" [position]="position.TOP_LEFT">
            </app-custom-tooltip>
  
            <app-custom-tooltip class="max-width-tooltip"
              *ngIf="tooltip_data?.length>0 && expProd.value === navigationTarget.DOCTALK" [tooltip_data]="tooltip_data"
              [view_identifier]="exploreIdentifiers.EXPLORE_DOCTALKS" [position]="position.TOP_LEFT">
            </app-custom-tooltip>
  
            <app-custom-tooltip class="max-width-tooltip"
              *ngIf="tooltip_data?.length>0 && expProd.value === navigationTarget.WEBINAR" [tooltip_data]="tooltip_data"
              [view_identifier]="exploreIdentifiers.EXPLORE_WEBINAR" [position]="position.TOP_LEFT">
            </app-custom-tooltip>
  
            <app-custom-tooltip class="max-width-tooltip"
              *ngIf="tooltip_data?.length>0 && expProd.value === navigationTarget.JOURNAL" [tooltip_data]="tooltip_data"
              [view_identifier]="exploreIdentifiers.EXPLORE_CLINICALREFERENCES" [position]="position.TOP_LEFT">
            </app-custom-tooltip>
  
            <a (click)="navigateFromExplore(expProd)" *ngIf="expProd.value !== navigationTarget.MY_DOWNLOAD
              && expProd.value !== navigationTarget.CONTRIBUTOR
              && expProd.value !== navigationTarget.REWARDS
              && expProd.value !== navigationTarget.CHATS"
              class="p-3 d-block bg-deep-green-100 ounded secondary-paragraph position-relative card-border cursor-poiner">
              <span class="mr-2">
                <img *ngIf="expProd.value=== exploreSection.CHANNEL" class="explore-icon-size" src={{expProd.icon_url}}
                  onerror="this.src='assets/themes/icons/gr/channels.svg'">
                <img *ngIf="expProd.value=== exploreSection.ONLINE_EVENT " class="explore-icon-size" src={{expProd.icon_url}}
                  onerror="this.src='assets/themes/icons/gr/online-event.svg'">
                <img *ngIf="expProd.value=== exploreSection.PHARMA" class="explore-icon-size" src={{expProd.icon_url}}
                  onerror="this.src='assets/themes/icons/gr/channels.svg'">
                <img *ngIf="expProd.value=== exploreSection.CME" class="explore-icon-size" src={{expProd.icon_url}}
                  onerror="this.src='assets/themes/icons/gr/cme.svg'">
                <img *ngIf="expProd.value=== exploreSection.DOCTALK" class="explore-icon-size" src={{expProd.icon_url}}
                  onerror="this.src='assets/themes/icons/gr/doctalks.svg'">
                <img *ngIf="expProd.value===exploreSection.WEBINAR" class="explore-icon-size" src={{expProd.icon_url}}
                  onerror="this.src='assets/themes/icons/gr/webinar.svg'">
                <img *ngIf="expProd.value===exploreSection.SURVEY" class="explore-icon-size" src={{expProd.icon_url}}
                  onerror="this.src='assets/themes/icons/gr/surveys.svg'">
                <img *ngIf="expProd.value===exploreSection.JOURNAL" class="explore-icon-size" src={{expProd.icon_url}}
                  onerror="this.src='assets/themes/icons/gr/clinical-notes.svg'">
                <img *ngIf="expProd.value===exploreSection.EVENT" class="explore-icon-size" src={{expProd.icon_url}}
                  onerror="this.src='assets/themes/icons/gr/offline-event.svg'">
                  <img *ngIf="expProd.value===exploreSection.LINK" class="explore-menu-icon" src={{expProd.icon_url}}  
                  onerror="this.src='assets/themes/icons/gr/connections.svg'">
                <img *ngIf="expProd.value===exploreSection.OTSUKAFORM" class="explore-menu-icon" src={{expProd.icon_url}}  
                  onerror="this.src='assets/themes/icons/gr/connections.svg'">
                <img *ngIf="expProd.value=== exploreSection.CLINICAL_CASES" class="explore-icon-size" src={{expProd.icon_url}}
                  onerror="this.src='assets/themes/icons/gr/clinical-case.svg'">
                <img *ngIf="expProd.value===exploreSection.POLL" class="explore-icon-size" src={{expProd.icon_url}}
                  onerror="this.src='assets/themes/icons/gr/q&a.svg'">
                <img *ngIf="expProd.value===exploreSection.DRUG_SAMPLE" class="explore-icon-size" src={{expProd.icon_url}}
                  onerror="this.src='assets/themes/icons/drug-sampal.svg'">
                <img *ngIf="expProd.value=== exploreSection.MY_BOOKMARKS" class="explore-icon-size" src={{expProd.icon_url}}
                  onerror="this.src='assets/themes/icons/gr/bookmark.svg'">
                <img *ngIf="expProd.value=== exploreSection.CONNECTION" class="explore-icon-size" src={{expProd.icon_url}}
                  onerror="this.src='assets/themes/icons/gr/connections.svg'">
                <img *ngIf="expProd.value=== exploreSection.INSIGHTS" class="explore-icon-size" src={{expProd.icon_url}}
                  onerror="this.src='assets/themes/icons/gr/connections.svg'">
                <img *ngIf="expProd.value=== exploreSection.GR_FILTER" class="explore-icon-size" src={{expProd.icon_url}}
                  onerror="this.src='assets/images/profile-explore/nejm.svg'">
                <img *ngIf="expProd.value=== exploreSection.CHATS" class="explore-icon-size" src={{expProd.icon_url}}
                  onerror="this.src='assets/themes/icons/gr/chat.svg'">
                <img *ngIf="expProd.value=== exploreSection.CALENDER" class="explore-icon-size" src={{expProd.icon_url}}
                  onerror="this.src='assets/themes/icons/gr/calendar.svg'">
                <img *ngIf="expProd.value=== exploreSection.EDITORS_CHOICE" class="explore-icon-size" src={{expProd.icon_url}}
                  onerror="this.src='assets/themes/icons/gr/insight-collector.svg'">
                <img *ngIf="expProd.value=== exploreSection.COMMUNITY" class="explore-icon-size" src={{expProd.icon_url}}
                  onerror="this.src='assets/themes/icons/gr/community.svg'">
                <img *ngIf="expProd.value=== 'dx'" class="explore-icon-size" src='https://media.docquity.com/doc-web-app/assets/images/web-dx-icon.svg'>
                <img style="height: 20px;" *ngIf="expProd.value===exploreSection.SHARE_POST && expProd.icon_url !=''" class="explore-menu-icon" src={{expProd.icon_url}} />
              </span>
              <span>
                {{expProd.name}}
              </span>
              <img class="newTagImg" [src]="expProd.value | newTagImage : this.dss.exploreNewTags" [ngStyle]="{'display':  expProd.value | newTags : this.dss.exploreNewTags}"  />
            </a>
          </div>
        </li>
      </ul>
    </div>
  </div>